module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAASJJREFUKBWVk4FtgzAQRW1PEFggbIBH6AZhhHaCZKNmg5IJ2hFgg3QAIBNA3ycGIctEqqWT7X/v2/hsrInaMAzVOI4na60npWimaWqcc7csy+otbpcJpgPQJ/OK+CVm02aRI1rN/INFHoyfTca+7wfiwfiy6NteuvLixK85hDoY/SomBph8WOBrTiNUCBN9csd4DXGBr2zXdVfO8ZbneRGDe3PMd+rz40JBmj1wR2/wlY5kqavYgZJy4L3Mbdg9CabEwLcurFKmoBeal4+H42qg4j/Vhj8GnzFUT/eMf/AvdjPKixMvTmc2nOFdHZ/yDXCWFjf0i/Lo4DNv4rd9JXki7oSuQ+9bX6MoiJuMy9tezSTmxg76qyogGVTINhSnjv+qPxtMxneO8xgoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/checkbox_not_selected.png
// module id = P1rc
// module chunks = 1